declare namespace $ {

	type $rise_resize_edge__repos_x_rise_resize_ratio_1 = $mol_type_enforce<
		ReturnType< $rise_resize_ratio['repos_x'] >
		,
		ReturnType< $rise_resize_edge['repos_x'] >
	>
	type $rise_resize_edge__repos_y_rise_resize_ratio_2 = $mol_type_enforce<
		ReturnType< $rise_resize_ratio['repos_y'] >
		,
		ReturnType< $rise_resize_edge['repos_y'] >
	>
	type $rise_resize_edge__on_drag_start_rise_resize_ratio_3 = $mol_type_enforce<
		ReturnType< $rise_resize_ratio['resize_start'] >
		,
		ReturnType< $rise_resize_edge['on_drag_start'] >
	>
	type $rise_resize_edge__on_drag_end_rise_resize_ratio_4 = $mol_type_enforce<
		ReturnType< $rise_resize_ratio['resize_end'] >
		,
		ReturnType< $rise_resize_edge['on_drag_end'] >
	>
	type $rise_resize_edge__x_rise_resize_ratio_5 = $mol_type_enforce<
		ReturnType< $rise_resize_ratio['left_top_edge_ratio_x'] >
		,
		ReturnType< $rise_resize_edge['x'] >
	>
	type $rise_resize_edge__repos_x_rise_resize_ratio_6 = $mol_type_enforce<
		ReturnType< $rise_resize_ratio['repos_x'] >
		,
		ReturnType< $rise_resize_edge['repos_x'] >
	>
	type $rise_resize_edge__repos_y_rise_resize_ratio_7 = $mol_type_enforce<
		ReturnType< $rise_resize_ratio['repos_y'] >
		,
		ReturnType< $rise_resize_edge['repos_y'] >
	>
	type $rise_resize_edge__on_drag_start_rise_resize_ratio_8 = $mol_type_enforce<
		ReturnType< $rise_resize_ratio['resize_start'] >
		,
		ReturnType< $rise_resize_edge['on_drag_start'] >
	>
	type $rise_resize_edge__on_drag_end_rise_resize_ratio_9 = $mol_type_enforce<
		ReturnType< $rise_resize_ratio['resize_end'] >
		,
		ReturnType< $rise_resize_edge['on_drag_end'] >
	>
	type $rise_resize_edge__x_rise_resize_ratio_10 = $mol_type_enforce<
		ReturnType< $rise_resize_ratio['left_bottom_edge_ratio_x'] >
		,
		ReturnType< $rise_resize_edge['x'] >
	>
	type $rise_resize_edge__repos_x_rise_resize_ratio_11 = $mol_type_enforce<
		ReturnType< $rise_resize_ratio['repos_x'] >
		,
		ReturnType< $rise_resize_edge['repos_x'] >
	>
	type $rise_resize_edge__repos_y_rise_resize_ratio_12 = $mol_type_enforce<
		ReturnType< $rise_resize_ratio['repos_y'] >
		,
		ReturnType< $rise_resize_edge['repos_y'] >
	>
	type $rise_resize_edge__on_drag_start_rise_resize_ratio_13 = $mol_type_enforce<
		ReturnType< $rise_resize_ratio['resize_start'] >
		,
		ReturnType< $rise_resize_edge['on_drag_start'] >
	>
	type $rise_resize_edge__on_drag_end_rise_resize_ratio_14 = $mol_type_enforce<
		ReturnType< $rise_resize_ratio['resize_end'] >
		,
		ReturnType< $rise_resize_edge['on_drag_end'] >
	>
	type $rise_resize_edge__x_rise_resize_ratio_15 = $mol_type_enforce<
		ReturnType< $rise_resize_ratio['right_bottom_edge_ratio_x'] >
		,
		ReturnType< $rise_resize_edge['x'] >
	>
	type $rise_resize_edge__repos_x_rise_resize_ratio_16 = $mol_type_enforce<
		ReturnType< $rise_resize_ratio['repos_x'] >
		,
		ReturnType< $rise_resize_edge['repos_x'] >
	>
	type $rise_resize_edge__repos_y_rise_resize_ratio_17 = $mol_type_enforce<
		ReturnType< $rise_resize_ratio['repos_y'] >
		,
		ReturnType< $rise_resize_edge['repos_y'] >
	>
	type $rise_resize_edge__on_drag_start_rise_resize_ratio_18 = $mol_type_enforce<
		ReturnType< $rise_resize_ratio['resize_start'] >
		,
		ReturnType< $rise_resize_edge['on_drag_start'] >
	>
	type $rise_resize_edge__on_drag_end_rise_resize_ratio_19 = $mol_type_enforce<
		ReturnType< $rise_resize_ratio['resize_end'] >
		,
		ReturnType< $rise_resize_edge['on_drag_end'] >
	>
	type $rise_resize_edge__x_rise_resize_ratio_20 = $mol_type_enforce<
		ReturnType< $rise_resize_ratio['right_top_edge_ratio_x'] >
		,
		ReturnType< $rise_resize_edge['x'] >
	>
	type $rise_resize_edge__repos_x_rise_resize_ratio_21 = $mol_type_enforce<
		ReturnType< $rise_resize_ratio['repos_x'] >
		,
		ReturnType< $rise_resize_edge['repos_x'] >
	>
	type $rise_resize_edge__repos_y_rise_resize_ratio_22 = $mol_type_enforce<
		ReturnType< $rise_resize_ratio['repos_y'] >
		,
		ReturnType< $rise_resize_edge['repos_y'] >
	>
	type $rise_resize_edge__on_drag_start_rise_resize_ratio_23 = $mol_type_enforce<
		ReturnType< $rise_resize_ratio['resize_start'] >
		,
		ReturnType< $rise_resize_edge['on_drag_start'] >
	>
	type $rise_resize_edge__on_drag_end_rise_resize_ratio_24 = $mol_type_enforce<
		ReturnType< $rise_resize_ratio['resize_end'] >
		,
		ReturnType< $rise_resize_edge['on_drag_end'] >
	>
	type $rise_resize_edge__y_rise_resize_ratio_25 = $mol_type_enforce<
		ReturnType< $rise_resize_ratio['top_left_edge_ratio_y'] >
		,
		ReturnType< $rise_resize_edge['y'] >
	>
	type $rise_resize_edge__repos_x_rise_resize_ratio_26 = $mol_type_enforce<
		ReturnType< $rise_resize_ratio['repos_x'] >
		,
		ReturnType< $rise_resize_edge['repos_x'] >
	>
	type $rise_resize_edge__repos_y_rise_resize_ratio_27 = $mol_type_enforce<
		ReturnType< $rise_resize_ratio['repos_y'] >
		,
		ReturnType< $rise_resize_edge['repos_y'] >
	>
	type $rise_resize_edge__on_drag_start_rise_resize_ratio_28 = $mol_type_enforce<
		ReturnType< $rise_resize_ratio['resize_start'] >
		,
		ReturnType< $rise_resize_edge['on_drag_start'] >
	>
	type $rise_resize_edge__on_drag_end_rise_resize_ratio_29 = $mol_type_enforce<
		ReturnType< $rise_resize_ratio['resize_end'] >
		,
		ReturnType< $rise_resize_edge['on_drag_end'] >
	>
	type $rise_resize_edge__y_rise_resize_ratio_30 = $mol_type_enforce<
		ReturnType< $rise_resize_ratio['top_right_edge_ratio_y'] >
		,
		ReturnType< $rise_resize_edge['y'] >
	>
	type $rise_resize_edge__repos_x_rise_resize_ratio_31 = $mol_type_enforce<
		ReturnType< $rise_resize_ratio['repos_x'] >
		,
		ReturnType< $rise_resize_edge['repos_x'] >
	>
	type $rise_resize_edge__repos_y_rise_resize_ratio_32 = $mol_type_enforce<
		ReturnType< $rise_resize_ratio['repos_y'] >
		,
		ReturnType< $rise_resize_edge['repos_y'] >
	>
	type $rise_resize_edge__on_drag_start_rise_resize_ratio_33 = $mol_type_enforce<
		ReturnType< $rise_resize_ratio['resize_start'] >
		,
		ReturnType< $rise_resize_edge['on_drag_start'] >
	>
	type $rise_resize_edge__on_drag_end_rise_resize_ratio_34 = $mol_type_enforce<
		ReturnType< $rise_resize_ratio['resize_end'] >
		,
		ReturnType< $rise_resize_edge['on_drag_end'] >
	>
	type $rise_resize_edge__y_rise_resize_ratio_35 = $mol_type_enforce<
		ReturnType< $rise_resize_ratio['bottom_left_edge_ratio_y'] >
		,
		ReturnType< $rise_resize_edge['y'] >
	>
	type $rise_resize_edge__repos_x_rise_resize_ratio_36 = $mol_type_enforce<
		ReturnType< $rise_resize_ratio['repos_x'] >
		,
		ReturnType< $rise_resize_edge['repos_x'] >
	>
	type $rise_resize_edge__repos_y_rise_resize_ratio_37 = $mol_type_enforce<
		ReturnType< $rise_resize_ratio['repos_y'] >
		,
		ReturnType< $rise_resize_edge['repos_y'] >
	>
	type $rise_resize_edge__on_drag_start_rise_resize_ratio_38 = $mol_type_enforce<
		ReturnType< $rise_resize_ratio['resize_start'] >
		,
		ReturnType< $rise_resize_edge['on_drag_start'] >
	>
	type $rise_resize_edge__on_drag_end_rise_resize_ratio_39 = $mol_type_enforce<
		ReturnType< $rise_resize_ratio['resize_end'] >
		,
		ReturnType< $rise_resize_edge['on_drag_end'] >
	>
	type $rise_resize_edge__y_rise_resize_ratio_40 = $mol_type_enforce<
		ReturnType< $rise_resize_ratio['bottom_right_edge_ratio_y'] >
		,
		ReturnType< $rise_resize_edge['y'] >
	>
	export class $rise_resize_ratio extends $rise_resize {
		left_top_edge_ratio_x( next?: number ): number
		Left_top_edge_ratio( ): $rise_resize_edge
		left_bottom_edge_ratio_x( next?: number ): number
		Left_bottom_edge_ratio( ): $rise_resize_edge
		right_bottom_edge_ratio_x( next?: number ): number
		Right_bottom_edge_ratio( ): $rise_resize_edge
		right_top_edge_ratio_x( next?: number ): number
		Right_top_edge_ratio( ): $rise_resize_edge
		top_left_edge_ratio_y( next?: number ): number
		Top_left_edge_ratio( ): $rise_resize_edge
		top_right_edge_ratio_y( next?: number ): number
		Top_right_edge_ratio( ): $rise_resize_edge
		bottom_left_edge_ratio_y( next?: number ): number
		Bottom_left_edge_ratio( ): $rise_resize_edge
		bottom_right_edge_ratio_y( next?: number ): number
		Bottom_right_edge_ratio( ): $rise_resize_edge
		ratio( ): number
		edges_ratio( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=ratio.view.tree.d.ts.map